<template>
  <div class="books-container">
    <div class="bootstrap-wrapper">
      <div class="container">
        <div class="row hidden-row"></div>
        <div class="row">
          <div class="col-12 my-8 mt-5">
            <h5>
              <unicon
                :name="'file-search-alt'"
                :fill="secCol"
                style="margin-right: 8px;"
              />
              <span>Actividades</span>
            </h5>
          </div>
        </div>
        <div class="row pb-4">
          <div class="col-md-14">
            <div class="row">
              <div class="col-16 text-center my-5">
                <button
                  v-for="category in categories"
                  :key="category"
                  :class="
                    `button mx-2 ${
                      selectedCategory === category ? 'secondary' : 'default'
                    }`
                  "
                  @click="filterCategories(category)"
                >
                  Desde {{ category }} años
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="row" v-if="loading">
          <div class="col-12 text-center">
            <Spinner />
          </div>
        </div>

        <div class="row" v-show="!loading" v-if="actsFiltered.length">
          <template v-for="(act, i) in actsFiltered">
            <ActivityCard :key="i" :data="act" @itemLoaded="addItemLoaded" />
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Spinner from "@/components/Spinner";
import ActivityCard from "@/components/activities/ActivityCard";

function onlyUnique(value, index, self) {
  return self.indexOf(value) === index;
}

export default {
  name: "Activities",
  components: {
    Spinner,
    ActivityCard,
  },
  mounted() {
    this.categories = this.acts.map(act => act.category).filter(onlyUnique);
  },
  data() {
    let { secCol } = this.$store.getters;

    return {
      selectedCategory: 6,
      secCol,
      acts: [
        {
          item: 1,
          name: "Adivina quién",
          category: 6,
        },
        {
          item: 2,
          name: "Entrevista para comprender",
          category: 6,
        },
        {
          item: 3,
          name: "Círculos concéntricos",
          category: 6,
        },
        {
          item: 1,
          name: "La obra y su contexto",
          category: 9,
        },
        {
          item: 2,
          name: "Comentaristas de medios",
          category: 9,
        },
        {
          item: 3,
          name: "Hoy seremos actores y actrices de leyendas",
          category: 9,
        },
        {
          item: 1,
          name:
            "¡Lleve de lo bueno, lleve de lo bueno... Lleve un poema, caballero!",
          category: 12,
        },
        {
          item: 2,
          name: "Juguemos Adivina quién",
          category: 12,
        },
        {
          item: 3,
          name: "Poematicons",
          category: 12,
        },
        {
          item: 4,
          name: "La máscara y el espejo",
          category: 12,
        },
        {
          item: 1,
          name: "Perfil de Facebook",
          category: 14,
        },
        {
          item: 2,
          name: "Una carta en una botella",
          category: 14,
        },
        {
          item: 3,
          name: "Blog latinoamericano",
          category: 14,
        },
        {
          item: 4,
          name: "Diseñador teatral",
          category: 14,
        },
        {
          item: 5,
          name: "Infopoema",
          category: 14,
        },
        {
          item: 6,
          name: "Cómic Siglo de Oro",
          category: 14,
        },
        {
          item: 7,
          name: "Crítica literaria",
          category: 14,
        },
        {
          item: 8,
          name: "Actitud lírica",
          category: 14,
        },
        {
          item: 9,
          name: "Rueda de prensa para personajes",
          category: 14,
        },
        {
          item: 1,
          name: "Para quienes no me conocen, me presento…",
          category: 16,
        },
        {
          item: 2,
          name: "Amor y deseo en la poesía",
          category: 16,
        },
      ],
      categories: [],
      itemsLoaded: [],
    };
  },
  computed: {
    actsFiltered() {
      return this.acts.filter(act => act.category === this.selectedCategory);
    },
    loading() {
      return !this.actsFiltered
        .map(actFiltered => actFiltered.item)
        .every(itemFiltered =>
          this.itemsLoaded.some(item => item === itemFiltered)
        );
    },
  },
  methods: {
    filterCategories(category) {
      this.itemsLoaded = [];
      this.selectedCategory = category;
    },
    addItemLoaded(itemLoaded) {
      this.itemsLoaded.push(itemLoaded);
    },
  },
  watch: {
    "selectLevel.selected"() {
      this.filter();
    },
  },
};
</script>

<style lang="scss" scoped>
.books-container {
  min-height: calc(100vh - 304px);
}

.subtitle {
  font-size: 14px;
}
</style>
